import { User, Role } from "appz";
import { Reducer } from "redux";
import { UserRole } from "user/constants";

enum ActionType {
    SetUser = "SET_USER",
}

interface SetUserAction {
    type: ActionType.SetUser;
    user?: User;
}

type UserAction = SetUserAction;

export const actionCreators = {
    updateUser: (user?: User) =>
        <SetUserAction>{
            type: ActionType.SetUser,
            user,
        },
};

export type UserState = User;

export const getId = ({ user }: { user: UserState }): string => user.id;

export const getRoles = ({ user }: { user: UserState }): Array<Role> =>
    user.roles;

export const getIsAuthenticated = ({ user }: { user: UserState }): boolean =>
    user.authenticated;

export const getUserName = ({ user }: { user: UserState }): string =>
    user.userName;

export const getEmail = ({ user }: { user: UserState }): string => user.email;

export const initialState: User = {
    id: "",
    roles: [],
    authenticated: false,
    userName: "",
    email: "",
    softDeleted: false,
};

export const reducer: Reducer<User, any> = (
    state: UserState = initialState,
    action: UserAction,
) => {
    if (!action || action.type === ActionType.SetUser) {
        if (action.user) {
            return {
                ...action.user,
            };
        }
    }

    // todo, add actions etc
    return state;
};
